import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { AppService } from "@root/app.service";

interface Channel {
  thirdparty_type: number;
  title: string;
  logo: string;
  bg_color: string;
}

@Component({
  selector: "host-connect-first-account",
  templateUrl: "./connect-first-account.component.html",
  styleUrls: ["./connect-first-account.component.scss"],
})
export class ConnectFirstAccountComponent implements OnInit {
  @Output() onSelectChannel = new EventEmitter();
  listOfChannel: Channel[] = [];
  loading = false;
  get isInternational() {
    return this.app.app.international;
  }

  constructor(private http: HttpClient, private app: AppService) {}

  ngOnInit() {
    this.loading = true;
    this.fetchChannelList();
  }

  private fetchChannelList() {
    this.http.get("/api/novice_guidance/v2/config").subscribe((rst: any) => {
      this.loading = false;
      this.listOfChannel = rst?.data?.channels;
    });
  }
}
